var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"store-info"}},[_c('v-card',{staticClass:"pa-3",attrs:{"min-height":"700px","flat":"","outlined":""}},[_vm._v(" StoreId: "),_c('h2',{staticClass:"pl-4"},[_vm._v(" "+_vm._s(_vm.store.id)+" ")]),_vm._v(" Name: "),_c('h2',{staticClass:"pl-4"},[_vm._v(" "+_vm._s(_vm.store.name)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }